import React, { Component } from 'react'
import modalType from './ModalHOC'
import { ALertHeaderText, AlertText } from '../BreakOutMode/styles'
import IconButton from 'material-ui/IconButton'
import FlatButton from 'material-ui/FlatButton'
import Clear from 'material-ui/svg-icons/content/clear'
import CheckCircle from 'material-ui/svg-icons/action/check-circle'
import SelectField from 'material-ui/SelectField'
import Mic from 'material-ui/svg-icons/av/mic'
import Video from 'material-ui/svg-icons/av/videocam'
import AudioOutput from 'material-ui/svg-icons/av/volume-up'
import { FeaturedVideo } from 'material-ui-icons'
import MenuItem from 'material-ui/MenuItem'
import { FormattedMessage } from 'react-intl'
import { bitrate_const, checkMobile, displayPermission, isSafari, isSentryBreadcrumbs } from '../../lib/lib'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import NotificationSystem from 'react-notification-system'

export const RedirectToBreakout = ({handleClose, redirectToBreakoutMode}) => (
  <div style={{padding: 24}}>
    <div
      className='flex justify-between items-center mb4'>
      <ALertHeaderText className='flex items-center'>
        <FormattedMessage id='main.modalBreakoutTitle'/>
      </ALertHeaderText>
      <div>
        <IconButton onClick={handleClose} iconStyle={{fill: '#afb8c5'}}>
          <Clear/>
        </IconButton>
      </div>
    </div>
    <div>
      <AlertText className='mb3' style={{color: '#29B87A'}}>
        <FormattedMessage id='main.modalBreakoutTitleBody1'/>
      </AlertText>
      <ALertHeaderText style={{lineHeight: 1.5}} className='mb4'>
        <FormattedMessage id='main.modalBreakoutTitleBody2'/>
      </ALertHeaderText>
      <div className='flex justify-end'>
        <div className='w4'>
          <FlatButton
            label={<FormattedMessage id='main.cancel'/>}
            labelStyle={{color: '#AFB8C4'}}
            fullWidth
            onClick={handleClose}
          />
        </div>
        <div className='ml2 w6 mb3'>
          <FlatButton
            label={<FormattedMessage id='main.modalBreakoutEnter'/>}
            fullWidth
            hoverColor='#12603e'
            backgroundColor='#29B87A'
            labelStyle={{color: '#FFFFFF'}}
            onClick={() => {
              redirectToBreakoutMode()
              handleClose()
            }}
          />
        </div>
      </div>
    </div>
  </div>
)

export class Settings extends Component {
  state = {
    audioDeviceLabel: this.props.audio_device[this.props.audio_device_value_index].label,
    audioOutputDeviceLabel: this.props.audio_output_array[this.props.audio_output_device_value_index].label,
    videoDeviceLabel: this.props.video_device[this.props.video_device_value_index].label,
    audioDeviceLabelInitial: null,
    audioOutputDeviceLabelInitial: null,
    videoDeviceLabelInitial: null,
    audioDevice_index: this.props.audio_device_value_index,
    audioOutputDevice_index: this.props.audio_output_device_value_index,
    videoDevice_index: this.props.video_device_value_index,
    bitrate_index: this.props.bitrate_index,
    bitrate: bitrate_const[this.props.bitrate_index].label,
    changedValues: 0
  }

  componentDidMount () {
    if (this.props.audio_device.length == 2) {// デバイスが1つしかない場合
      this.props.audio_device.map((value, deviceIndex) => {
        if (value.deviceId) {
          this.setState({
            audioDeviceLabel: value.label,
            audioDeviceLabelInitial: value.label,
            audioDevice_index: deviceIndex
          })
        }
      })
    } else { // デバイスが2つ以上あって、以前に設定された値がある場合はそれを選ぶ、ない場合はデフォルトを選ぶ
      let audioDeviceId = localStorage.getItem('audioDeviceId')
      if (audioDeviceId == 'default' || !audioDeviceId) {
        audioDeviceId = 'null'
      }
      let detectAudioDevice = false
      this.props.audio_device.map((value, deviceIndex) => {
        if (value.deviceId == audioDeviceId) {
          this.setState({
            audioDeviceLabel: value.label,
            audioDeviceLabelInitial: value.label,
            audioDevice_index: deviceIndex
          })
          detectAudioDevice = true
        }
      })
      if (!detectAudioDevice) { // 見つからなかったので、defaultを選択する。
        this.props.audio_device.map((value, deviceIndex) => {
          if (value.deviceId == 'default') {
            this.setState({
              audioDeviceLabel: value.label,
              audioDeviceLabelInitial: value.label,
              audioDevice_index: deviceIndex
            })
          }
        })
      }
    }
    if (this.props.audio_output_array.length == 2) {// デバイスが1つしかない場合
      this.props.audio_output_array.map((value, deviceIndex) => {
        if (value.deviceId) {
          this.setState({
            audioOutputDeviceLabel: value.label,
            audioOutputDeviceLabelInitial: value.label,
            audioOutputDevice_index: deviceIndex
          })
        }
      })
    } else { // デバイスが2つ以上あって、以前に設定された値がある場合はそれを選ぶ、ない場合はデフォルトを選ぶ
      let audioOutputDeviceId = localStorage.getItem('audioOutputDeviceId')
      if (audioOutputDeviceId == 'default' || !audioOutputDeviceId) {
        audioOutputDeviceId = 'null'
      }
      let detectAudioDevice = false
      this.props.audio_output_array.map((value, deviceIndex) => {
        if (value.deviceId == audioOutputDeviceId) {
          this.setState({
            audioOutputDeviceLabel: value.label,
            audioOutputDeviceLabelInitial: value.label,
            audioOutputDevice_index: deviceIndex
          })
          detectAudioDevice = true
        }
      })
      if (!detectAudioDevice) { // 見つからなかったので、defaultを選択する。
        this.props.audio_output_array.map((value, deviceIndex) => {
          if (value.deviceId == 'default') {
            this.setState({
              audioOutputDeviceLabel: value.label,
              audioOutputDeviceLabelInitial: value.label,
              audioOutputDevice_index: deviceIndex
            })
          }
        })
      }
    }
    if (this.props.video_device.length == 2) {// デバイスが1つしかない場合
      this.props.video_device.map((value, deviceIndex) => {
        if (value.deviceId) {
          this.setState({
            videoDeviceLabel: value.label,
            videoDeviceLabelInitial: value.label,
            videoDevice_index: deviceIndex
          })
        }
      })
    } else { // デバイスが2つ以上あって、以前に設定された値がある場合はそれを選ぶ、ない場合はデフォルトを選ぶ
      let videoDeviceId = localStorage.getItem('videoDeviceId')
      if (videoDeviceId == 'default') {
        videoDeviceId = 'null'
      }
      let detectVideoDevice = false
      this.props.video_device.map((value, deviceIndex) => {
        if (value.deviceId == videoDeviceId || !videoDeviceId) {
          this.setState({
            videoDeviceLabel: value.label,
            videoDeviceLabelInitial: value.label,
            videoDevice_index: deviceIndex
          })
          detectVideoDevice = true
        }
      })
      if (!detectVideoDevice) { // 見つからなかったので、defaultを選択する。
        this.props.video_device.map((value, deviceIndex) => {
          if (value.deviceId == 'default') {
            this.setState({
              videoDeviceLabel: value.label,
              videoDeviceLabelInitial: value.label,
              videoDevice_index: deviceIndex
            })
          }
        })
      }
    }
  }

  handleAudioDeviceChange = (event, index, audioDeviceLabel) => {
    try {
      if (index == 0) {
        return
      }
      this.setState({audioOutputDevice_index: index, audioDeviceLabel: audioDeviceLabel})
      this.props.audio_device.map((value, deviceIndex) => {
        if (index === deviceIndex) {
          localStorage.setItem('audioDeviceId', value.deviceId)
        }
      })
    }
    catch (error) {
      const message = 'Audio devices handleAudioDeviceChange() failed'
      isSentryBreadcrumbs(error, message)
    }
  }
  handleAudioOutputDeviceChange = (event, index, audioOutputDeviceLabel) => {
    try {
      if (index == 0) {
        return
      }
      console.log(this.props.audio_output_array)
      this.props.changeAudioOutPut(this.props.audio_output_array[index].deviceId)
      this.setState({audioOutputDeviceId: index, audioOutputDeviceLabel})
      this.props.audio_output_array.map((value, deviceIndex) => {
        if (index === deviceIndex) {
          localStorage.setItem('audioOutputDeviceId', value.deviceId)
        }
      })
    }
    catch (error) {
      const message = 'Audio devices handleAudioOutputDeviceChange() failed'
      isSentryBreadcrumbs(error, message)
    }
  }
  handleVideoDeviceChange = (event, index, videoDeviceLabel) => {
    try {
      if (index == 0) {
        return
      }
      this.setState({videoDevice_index: index, videoDeviceLabel: videoDeviceLabel})
      this.props.video_device.map((value, deviceIndex) => {
        if (index === deviceIndex) {
          localStorage.setItem('videoDeviceId', value.deviceId)
          localStorage.setItem('videoDeviceLabel', videoDeviceLabel)
        }
      })
    }
    catch (error) {
      const message = 'Audio devices handleAudioOutputDeviceChange() failed'
      isSentryBreadcrumbs(error, message)
    }
  }
  handleBitrateChange = (event, index, bitrate) => {
    try {
      if (index == 0) {
        return
      }
      this.setState({bitrate_index: index, bitrate})
    }
    catch (error) {
      const message = 'Bitrate handleBitrateChange() failed'
      isSentryBreadcrumbs(error, message)
    }
  }

  render () {
    return (
      <div style={{padding: 24}}>
        <div
          className='flex justify-between items-center mb4'>
          <ALertHeaderText className='flex items-center'>
            <FormattedMessage id='main.deviceSetting'/>
          </ALertHeaderText>
          <div>
            <IconButton onClick={this.props.handleClose} iconStyle={{fill: '#afb8c5'}}>
              <Clear/>
            </IconButton>
          </div>
        </div>
        {!isSafari() && <div className='flex justify-between items-center mb3'>
          <div className='w-10'>
            <AudioOutput style={{fill: '#6B7C93'}}/>
          </div>
          {<SelectField
            className='w90'
            underlineShow={false}
            selectedMenuItemStyle={{backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A'}}
            value={this.props.disabledAudioPermission ? displayPermission.audio : this.state.audioOutputDeviceLabel}
            onClick={() => {this.props.getDeviceList()}}
            onChange={this.handleAudioOutputDeviceChange}
            menuItemStyle={{height: 48, paddingTop: 8}}
            style={{backgroundColor: '#FAFAFA', paddingLeft: '1rem'}}
          >
            {this.props.audio_output_array && this.props.audio_output_array.map((value, index) => {

              if (this.props.disabledAudioPermission && index == 0) {
                return (
                  <MenuItem key={0} value={displayPermission.audio} primaryText={displayPermission.audio}
                            rightIcon={null}/>
                )
              }
              if (!this.props.disabledAudioPermission) {
                return (
                  <MenuItem key={index} value={value.label} primaryText={value.label}
                            rightIcon={(this.state.audioOutputDeviceLabel === value.label)
                              ? (<CheckCircle style={{fill: '#29B87A'}}/>) : (<div/>)}/>
                )
              }
            })}
          </SelectField>}
        </div>}
        <div className='flex justify-between items-center mb3'>
          <div className='w-10'>
            <Mic style={{fill: '#6B7C93'}}/>
          </div>
          <SelectField
            className='w90'
            underlineShow={false}
            selectedMenuItemStyle={{backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A'}}
            value={this.props.disabledAudioPermission ? displayPermission.audio : this.state.audioDeviceLabel}
            onClick={() => {this.props.getDeviceList()}}
            onChange={this.handleAudioDeviceChange}
            menuItemStyle={{height: 48, paddingTop: 8}}
            style={{backgroundColor: '#FAFAFA', paddingLeft: '1rem'}}
          >
            {this.props.audio_device && this.props.audio_device.map((value, index) => {

              if (this.props.disabledAudioPermission && index == 0) {
                return (
                  <MenuItem key={0} value={displayPermission.audio} primaryText={displayPermission.audio}
                            rightIcon={null}/>
                )
              }
              if (!this.props.disabledAudioPermission) {
                return (
                  <MenuItem key={index} value={value.label} primaryText={value.label}
                            rightIcon={(this.state.audioDeviceLabel === value.label)
                              ? (<CheckCircle style={{fill: '#29B87A'}}/>) : (<div/>)}/>
                )
              }
            })}
          </SelectField>
        </div>
        <div className='flex justify-between items-center mb3'>
          <div className='w-10'>
            <Video style={{fill: '#6B7C93'}}/>
          </div>
          <SelectField
            className='w90'
            underlineShow={false}
            selectedMenuItemStyle={{backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A'}}
            value={this.props.disabledVideoPermission ? displayPermission.video : this.state.videoDeviceLabel}
            onChange={this.handleVideoDeviceChange}
            onClick={() => {this.props.getDeviceList()}}
            menuItemStyle={{height: 48, paddingTop: 8}}
            style={{backgroundColor: '#FAFAFA', paddingLeft: '1rem'}}
            // fullWidth
          >
            {this.props.video_device && this.props.video_device.map((value, index) => {
              if (this.props.disabledVideoPermission && index == 0) {
                return (
                  <MenuItem key={0} value={displayPermission.video} primaryText={displayPermission.video}
                            rightIcon={null}/>
                )
              }
              if (!this.props.disabledVideoPermission) {
                return (
                  <MenuItem key={index} value={value.label} primaryText={value.label}
                            rightIcon={(this.state.videoDeviceLabel === value.label)
                              ? (<CheckCircle style={{fill: '#29B87A'}}/>) : (<div/>)}/>)
              }
            })}
          </SelectField>
        </div>
        <div className='flex justify-between items-center mb3'>
          <div className='w-10'>
            <FeaturedVideo style={{fill: '#6B7C93'}}/>
          </div>
          <SelectField
            className='w90'
            underlineShow={false}
            selectedMenuItemStyle={{backgroundColor: 'rgba(136, 224, 168, 0.18)', color: '#29B87A'}}
            value={this.state.bitrate}
            onChange={this.handleBitrateChange}
            menuItemStyle={{height: 48, paddingTop: 8}}
            style={{backgroundColor: '#FAFAFA', paddingLeft: '1rem'}}
          >
            {bitrate_const.map((value, index) => {
              return (
                <MenuItem key={index} value={value.label} primaryText={value.label}
                          rightIcon={(this.state.bitrate === value.bitrate)
                            ? (<CheckCircle style={{fill: '#29B87A'}}/>) : (<div/>)}/>
              )
            })}
          </SelectField>
        </div>

        <div className='flex justify-end'>
          <div className='w4'>
            <FlatButton
              label={<FormattedMessage id='main.cancel'/>}
              labelStyle={{color: '#AFB8C4'}}
              fullWidth
              onClick={this.props.handleClose}
            />
          </div>
          <div className='ml2 w4 mb3'>
            <FlatButton
              label={<FormattedMessage id='main.save'/>}
              fullWidth
              hoverColor='#d0b667'
              backgroundColor='#FDD868'
              labelStyle={{color: '#8B7124'}}
              onClick={() => {
                this.props.handleDeviceSave(
                  this.state.audioDevice_index,
                  this.state.videoDevice_index,
                  this.state.bitrate_index
                )
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export const Plugin = ({handleClose}) => (
  <div style={{padding: 24}}>
    <div className='flex justify-between items-center mb4'>
      <ALertHeaderText className='flex items-center'>
        <FormattedMessage id='main.modalScreenShare'/>
      </ALertHeaderText>
      <div>
        <IconButton onClick={handleClose} iconStyle={{fill: '#afb8c5'}}>
          <Clear/>
        </IconButton>
      </div>
    </div>
    <div>
      <AlertText
        onClick={() => { window.open('https://chrome.google.com/webstore/detail/workshop-screensharing/fpkehedblglkhoinapeaecjallokpekh')}}
        className='mb3' style={{color: '#29B87A'}}>
        <FormattedMessage id='main.modalScreenShareInstall'/>
      </AlertText>
    </div>
  </div>
)

export const EndCall = ({handleClose, hangupConf}) => (
  <div style={{padding: 24}}>
    <div
      className='flex justify-between items-center mb4'>
      <ALertHeaderText className='flex items-center'>
        <FormattedMessage id='main.endTitle'/>
      </ALertHeaderText>
      <div>
        <IconButton onClick={handleClose} iconStyle={{fill: '#afb8c5'}}>
          <Clear/>
        </IconButton>
      </div>
    </div>
    <div>
      <AlertText className='mb3'>
        <FormattedMessage id='main.endBody1'/>
      </AlertText>
      <ALertHeaderText style={{lineHeight: 1.5}} className='mb4'>
        <FormattedMessage id='main.endBody2'/>
      </ALertHeaderText>
      <div className='flex justify-end'>
        <div className='w4'>
          <FlatButton
            label={<FormattedMessage id='main.cancel'/>}
            labelStyle={{color: '#AFB8C4'}}
            fullWidth
            onClick={handleClose}
          />
        </div>
        <div className='ml2 w6 mb3'>
          <FlatButton
            label={<FormattedMessage id='main.endEnter'/>}
            fullWidth
            backgroundColor='#F01631'
            labelStyle={{color: '#FFFFFF'}}
            onClick={() => {
              handleClose()
              hangupConf()
            }}
          />
        </div>
      </div>
    </div>
  </div>
)

export class CopyLink extends Component {
  constructor (props) {
    super(props)
    this.notificationSystem = React.createRef()
  }

  handlePopupStatus = () => {
    const notification = this.notificationSystem.current
    notification.addNotification({
      message: 'URLがコピーされました',
      level: 'success',
      position: 'tc',
      autoDismiss: 3
    })
  }

  render () {
    const notificationStyle = {
      NotificationItem: {
        DefaultStyle: {
          fontSize: '14px',
          height: '2.5vw',
          width: '25vw',
          right: '5vw',
          top: '-4vw !important'
        }
      }
    }
    const {handleClose, pathname} = this.props
    return (
      <div style={{padding: 24}}>
        <div>
          <div>
            <IconButton onClick={handleClose} iconStyle={{fill: '#afb8c5'}}
                        style={{float: 'right', bottom: '23px', left: '25px'}}>
              <Clear/>
            </IconButton>
          </div>
          <div style={{textAlign: 'center'}}>
            <ALertHeaderText>
              招待URLを共有して、参加者を招待してください
            </ALertHeaderText>
            <AlertText>
              <div>
                <div className="copyUrl" style={{}}>
                  {window.location.host}{pathname}
                </div>
                <CopyToClipboard text={window.location.href} onCopy={() => {
                  this.handlePopupStatus()
                }}>
                  <FlatButton
                    label={'招待URLをコピー'}
                    hoverColor={'#009944'}
                    backgroundColor="#009944"
                    className="btnInviteCopy"
                    style={{borderRadius: '5px', left: '0px', padding: '10px', height: 'auto'}}
                    labelStyle={{color: '#FFFFFF'}}/>
                </CopyToClipboard>
              </div>
            </AlertText>
          </div>
        </div>
        <div className={checkMobile() ? 'success-msg' : 'success-msg-web'}>
          <NotificationSystem ref={this.notificationSystem} style={notificationStyle}/>
        </div>
      </div>
    )
  }
}

const Modal = ({children}) => (
  <div>
    {children}
  </div>
)

export default modalType(Modal)



// WEBPACK FOOTER //
// ./src/routes/SeminarMode/Modals.js